import React from "react";
import { Card } from "react-bootstrap";
import { getContrastColor } from "utils/utils";

function TopAgentsSection({ topAgents }) {
  return (
    <Card
      style={{
        marginBottom: "32px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <Card.Body className="p-3">
        <h2
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          TOP 5 Agent
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "16px",
          }}
          className="top-agents-grid"
        >
          {topAgents.map((agent) => (
            <Card
              key={agent.id}
              style={{
                border: "none",
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                background: agent.tierColor,
                color: getContrastColor(agent.tierColor),
              }}
            >
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  padding: "5px",
                  background: "transparent",
                  color: "inherit",
                }}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  <img
                    src={agent.image || `/rank-${agent.tier}.png`}
                    alt={`${agent.tierName} icon`}
                    style={{ width: "48px", height: "48px" }}
                  />
                </div>
                <div>
                  <div
                    style={{ fontSize: "16px", fontWeight: "bold" }}
                    className="agent-name"
                  >
                    {agent.name}
                  </div>
                  <div
                    style={{
                      textTransform: "capitalize",
                    }}
                    className="tier-name"
                  >
                    {agent.tierName}
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export default TopAgentsSection;
